import { computed, Directive, input } from '@angular/core';
import { cn } from '@shared/helpers/cn';

@Directive({
  selector: '[appAvatar]',
  standalone: true,
  host: { '[class]': 'styles()' },
})
export class AppAvatarDirective {
  class = input<string>();
  shape = input<'circle' | 'square'>('circle');
  size = input<'small' | 'medium'>('medium');
  avatarColor = input<'purple' | 'blue' | 'green' | 'yellow' | 'red'>('purple');

  #base = 'inline-flex items-center justify-center overflow-hidden';

  public styles = computed(() => {
    return cn(
      this.#base,
      {
        'w-8 h-8': this.size() === 'small',
        'w-16 h-16 mb-4': this.size() === 'medium',
        'rounded-xl': this.shape() === 'square',
        'rounded-full': this.shape() === 'circle',
        'bg-purple-100 text-purple-600': this.avatarColor() === 'purple',
        'bg-blue-100 text-blue-600': this.avatarColor() === 'blue',
        'bg-green-100 text-green-600': this.avatarColor() === 'green',
        'bg-yellow-100 text-yellow-600': this.avatarColor() === 'yellow',
        'bg-red-100 text-red-600': this.avatarColor() === 'red',
      },
      this.class(),
    );
  });
}
